import React, { useState, useEffect } from 'react';
import { Box, Button, Paper, Typography, TextField } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import TextInput from '../../Common/textInput';
import Label from '../../Common/label';
import TwoFactor from '../TwoFactor';
import IpConfirmation from '../IpConfirmation';
import NewPaymentMethod from '../NewPaymentMethod';

import requestMailErrorSelector from '../../../selectors/resetPassword';
import { resetPasswordMail } from '../../../actions/authentication';
import { showErrorSnackbar } from '../../../actions/snackbar';
import ReCAPTCHA from 'react-google-recaptcha';
import { setToken, getToken } from '../../../helpers/localStorageCache';
import './styles.css';

function SignIn({ handleLogin, classes }) {
  const dispatch = useDispatch();
  const findRegion = new URLSearchParams(window.location.search).get('region');
  let value = null
  if (findRegion != null) {
    value = findRegion
  }
  else {
    value = getToken('region');
  }
  const recaptchaRef = React.createRef();
  const errorSelector = useSelector(requestMailErrorSelector);
  const [error, setError] = useState(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [forgotPassword, setForgotPassword] = useState(false);
  const [forgotPasswordError, setForgotPasswordError] = useState({});
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [twoFactor, setTwoFactor] = useState(false);
  const [ipConfirmation, setIpConfirmation] = useState(false);
  const [newPaymentMethod, setNewPaymentMethod] = useState(false);
  const [captchaVal, setCaptchaVal] = useState('');
  const [ip, setIp] = useState('');
  const [region, setRegion] = useState(value);

  useEffect(
    () => setForgotPasswordError({ ...error, ...errorSelector }),
    [errorSelector]
  );

  const handleCaptcha = () => {
    const value = recaptchaRef.current.getValue();
    setCaptchaVal(value);
  }
  if (twoFactor) {
    return (
      <TwoFactor classes={classes} setTwoFactor={setTwoFactor} email={email} />
    );
  }
  if (ipConfirmation) {
    return (
      <IpConfirmation classes={classes} setIpConfirmation={setIpConfirmation} ip={ip} email={email} />
    );
  }
  if (newPaymentMethod) {
    return (
      <NewPaymentMethod classes={classes} setNewPaymentMethod={setNewPaymentMethod} />
    );
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) {
      return setError({ message: 'email is invalid' });
    }

    if (forgotPassword) {
      const { hostname } = window.location;
      const subdomain = hostname.split('.')[0];

      return dispatch(resetPasswordMail({ email, hostname: subdomain, token: captchaVal })).then(() => {
        setSubmitDisabled(false);
      });
    }

    if (!password) {
      return setError({ message: 'password is invalid' });
    }

    setSubmitDisabled(true);
    setToken('region', region);

    return handleLogin({ email, password }).then((res) => {
       if(typeof res?.payload === 'string'){
        dispatch(showErrorSnackbar(res?.payload));
      }
      if (res?.error_code == 402) {
        setIp(res?.ip)
        setIpConfirmation(true)
        setSubmitDisabled(false);
        return;
      }
      if (res?.error_code == 403) {
        setTwoFactor(true);
        setSubmitDisabled(false);
        return;
      }
      if (res?.error_code == 404) {
        setNewPaymentMethod(true);
        setSubmitDisabled(false);
        return;
      }
      if (res?.error_code == 405) {
        dispatch(showErrorSnackbar('Your account has been suspended'));
        setSubmitDisabled(false);
        return;
      }
      if (res?.error_code == 406) {
        const tries = 5 - res?.attempts;
        if (tries > 0)
          dispatch(showErrorSnackbar(`You have ${tries} attempts remaining`));
        else
          dispatch(showErrorSnackbar('you have been locked out of your account please click on forgot password to reset'));
        setSubmitDisabled(false);
        return;
      }
      if (res?.error_code == 407) {
        dispatch(showErrorSnackbar('you have been locked out of your account please click on forgot password to reset'));
        setSubmitDisabled(false);
        return;
      }
      if (res?.error) {
        setError({ message: 'Region or Email invalid' });
      }

      setSubmitDisabled(false);
    });
  };

  return (
    <Paper className={classes.paper} elevation={0}>
      <Typography component="h1" variant="h5" className={classes.loginHeading}>
        {forgotPassword ? 'Forgot Password' : 'Login'}
      </Typography>

      {error && <Typography className={classes.errorMessage}>{error.message}</Typography>}

      <form onSubmit={handleSubmit}>
        {/* {(region==null) && <Typography gutterBottom variant="h6" className={classes.heading}>
          Region
        </Typography>}

        {(region==null) &&<TextField
          required
          fullWidth
          error={Boolean(forgotPassword && forgotPasswordError && forgotPasswordError.email)}
          name="region"
          variant="outlined"
          placeholder="please enter your region"
          type="name"
          className={classes.field}
          value={region}
          helperText={forgotPassword && forgotPasswordError && forgotPasswordError.email}
          onChange={e => setRegion(e.target.value)}
        />} */}
        <Label>
          Email
        </Label>

        <TextInput
          required
          fullWidth
          error={Boolean(forgotPassword && forgotPasswordError && forgotPasswordError.email)}
          name="username"
          variant="outlined"
          placeholder="user@mail.com"
          type="email"
          className={classes.field}
          value={email}
          helperText={forgotPassword && forgotPasswordError && forgotPasswordError.email}
          onChange={e => setEmail(e.target.value)}
        />


        {!forgotPassword && (
          <div>
            <Label>
              Password
            </Label>
            <TextInput
              required
              fullWidth
              name="password"
              variant="outlined"
              placeholder="********"
              type="password"
              className={classes.field}
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>
        )}
        {/* <ReCAPTCHA
          ref={recaptchaRef}
          sitekey="6Ldkh6kcAAAAAC1RPyyVSvU6zdfi7xgHbxpw-FpS"
          onChange={handleCaptcha}
        /> */}

        <button
          type="button"
          className={classes.linkButton}
          onClick={() => setForgotPassword(!forgotPassword)}
        >
          {forgotPassword ? 'Sign In' : 'Forgot Password?'}
        </button>

        <Button disableRipple id='sign-in-btn' className={classes.submitButton} type="submit" disabled={submitDisabled}>
          {!forgotPassword ? 'Sign In' : 'Get Email'}
        </Button>
          <div style={{fontFamily:'Poppins',fontSize:'13px',marginTop:10}}>Brandcil's <a target='_blank' style={{color:'#0d6efd',textDecoration:'underline'}} href="https://brandcil.com/privacy-policy">Privacy Policy</a> and <a target='_blank' style={{color:'#0d6efd',textDecoration:'underline'}} href="https://brandcil.com/terms-conditions">Terms & Conditions</a></div>
      </form>

    </Paper>
  );
}

export default SignIn;
